import { gql, useMutation } from '@apollo/client';

import { GET_HOLIDAY_LOCATIONS_BY_COMPANY } from './get-holiday-locations-by-company.hook';

export const COPY_HOLIDAY_LOCATIONS_IN_COMPANY = gql`
  mutation copyHolidayLocationsInCompany($payload: CopyHolidayLocationsInCompanyInput!) {
    copyHolidayLocationsInCompany(payload: $payload) {
      _id
    }
  }
`;

export const useCopyHolidayLocationsInCompany = () => {
  const [copyHolidayLocationsInCompany] = useMutation(COPY_HOLIDAY_LOCATIONS_IN_COMPANY, {
    refetchQueries: [GET_HOLIDAY_LOCATIONS_BY_COMPANY],
  });

  return copyHolidayLocationsInCompany;
};
